export const handleNavigateToTab = (link: string) => {
    window.open(`${link}`, '_blank');
};